<form [formGroup]="baseFormGroup" #f="ngForm" class="mt-4 pl -2">
  <div class="form-group row">
      <div class="col-md-6">
        <yt-dropdown-picklist 
        [ModelName]="'orgjed'" 
        [GetName]="'get'" 
        [ModelProperty]="'Naziv'"
        [OrderBy]="'Naziv'" 
        [AllowAddNew]="false" 
        formControlName="OrgJedID"
        [Label]="'USER.ORGJEDID.SINGULAR'"
        [ngClass]="{ 'is-invalid': submitted && fc.OrgJedID.invalid }"
        [AutoSelect]="'true'">
      </yt-dropdown-picklist>
        <div class="form-error" *ngIf="submitted && fc.OrgJedID.invalid">
          <span *ngFor="let validation of errorMessages.OrgJedID">
            <span class="error-message" *ngIf="fc.OrgJedID.hasError(validation.type)"><span
                translate="{{ validation.message }}"></span></span>
          </span>
        </div>
      </div>
      <div class="col-md-6">
        <yt-dropdown-picklist
        [ModelName]="'podvrstadokumentastavka'"
        [GetName]="'GetByUrl'"
        [ModelProperty]="'Sifra,Naziv'"
        [GetParameters]='modelData.MainList.GetParameters'
        formControlName="PodVrstaDokumentaStavkaID"
         [Label]="'KOMITENTUGOVOR.PODVRSTADOKUMENTASTAVKA.SINGULAR'"
         [ngClass]="{'is-invalid':submitted && fc.PodVrstaDokumentaStavkaID.invalid}"
         (OnItemSelected)="onPodVrstaSelect($event)">
       </yt-dropdown-picklist>
       <div class="form-error" *ngIf="submitted && fc.PodVrstaDokumentaStavkaID.invalid">
         <span *ngFor="let validation of errorMessages.PodVrstaDokumentaStavkaID">
           <span class="error-message" *ngIf="fc.PodVrstaDokumentaStavkaID.hasError(validation.type)">
             <span translate="{{ validation.message }}"></span>
           </span>
         </span>
       </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-6">
        <yt-dropdown-picklist
        [ModelName]="'komitent'"
        [GetName]="'get'"
        [ModelProperty]="'SNaziv,Mesto'"
        [OrderBy]="'SNaziv'"
        [AllowAddNew]="true"
        [AllowEdit]="true"
        formControlName="KomitentID"
        [Label]="'KOMITENTUGOVOR.KOMITENT.SINGULAR'">
      </yt-dropdown-picklist>
      <div class="form-error" *ngIf="submitted && fc.KomitentID.invalid">
          <span *ngFor="let validation of errorMessages.KomitentID">
              <span class="error-message" *ngIf="fc.KomitentID.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
          </span>
      </div>
    </div>
      <div class="col-md-6">          
        <yt-input 
          [Type]="'text'" 
          [Label]="'KOMITENTUGOVOR.BROJDOKUMENTA.SINGULAR'" 
          formControlName="BrojDokumenta2" 
          [ngClass]="{'is-invalid': submitted && fc.BrojDokumenta2.invalid}">
        </yt-input>
        <div class="form-error" *ngIf="submitted && fc.BrojDokumenta2.invalid">
          <span *ngFor="let validation of errorMessages.BrojDokumenta2">
            <span class="error-message" *ngIf="fc.BrojDokumenta2.hasError(validation.type)"><span
                translate="{{ validation.message }}"></span></span>
          </span>
        </div>
        <!-- <yt-input [Type]="'text'" 
        [Label]="'KOMITENTUGOVOR.BROJDOKUMENTA.SINGULAR'" 
        formControlName="BrojDokumenta" 
        [ngClass]="{'is-invalid': submitted && fc.BrojDokumenta.invalid}">
        </yt-input> -->
        <!-- <div class="form-error" *ngIf="submitted && fc.BrojDokumenta.invalid">
          <span *ngFor="let validation of errorMessages.BrojDokumenta">
            <span class="error-message" *ngIf="fc.BrojDokumenta.hasError(validation.type)"><span
                translate="{{ validation.message }}"></span></span>
          </span>
        </div> -->
              <!-- <div class="col-sm-1">
        <div class="input-group-append">
          <span class="span-control">/</span>
          <span *ngIf="baseFormGroup.get('Datum').value != null" class="span-control">{{
            baseFormGroup.get("Datum").value.year }}</span>
        </div>
      </div> -->
      </div>
    </div>
    <div class="form-group row">
      <div class="col-md-4">
        <yt-fw-date-picker-popup
            name="txtDatum"
            formControlName="Datum"
            [ngClass]="{'is-invalid' : submitted && fc.Datum.invalid}"
            [Label]="'KOMITENTUGOVOR.DATUM.SINGULAR'">
        </yt-fw-date-picker-popup>
        <div class="form-error" *ngIf="submitted && fc.Datum.invalid">
            <span *ngFor="let validation of errorMessages.Datum">
                <span class="error-message" *ngIf="fc.Datum.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
            </span>
        </div>
      </div>
    <div class="col-md-4">
      <yt-fw-date-picker-popup
          name="txtOdDatuma"
          formControlName="OdDatuma"
          [ngClass]="{'is-invalid' : submitted && fc.OdDatuma.invalid}"
          [Label]="'KOMITENTUGOVOR.ODDATUMA.SINGULAR'">
      </yt-fw-date-picker-popup>
      <div class="form-error" *ngIf="submitted && fc.OdDatuma.invalid">
          <span *ngFor="let validation of errorMessages.OdDatuma">
              <span class="error-message" *ngIf="fc.OdDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
          </span>
      </div>
  </div>
  <div class="col-md-4">
    <yt-fw-date-picker-popup
        name="txtDoDatuma"
        formControlName="DoDatuma"
        [ngClass]="{'is-invalid' : submitted && fc.DoDatuma.invalid}"
        [Label]="'KOMITENTUGOVOR.DODATUMA.SINGULAR'">
    </yt-fw-date-picker-popup>
    <div class="form-error" *ngIf="submitted && fc.DoDatuma.invalid">
        <span *ngFor="let validation of errorMessages.DoDatuma">
            <span class="error-message" *ngIf="fc.DoDatuma.hasError(validation.type)"><span translate="{{validation.message}}"></span></span>
        </span>
    </div>
  </div>
  </div>  
    <div class="row">
      <div class="col-md-12">
        <yt-komitent-ugovor-stavka-update-container #baseInlineContainer
          [DetailModelData]="modelData.MainList.DetailList[0]" [ParentPropertyName]="'KomitentUgovorID'"
          [ParentPropertyValue]="Item.ID" [Parameters]="TransferParameters">
        </yt-komitent-ugovor-stavka-update-container>
      </div>
    </div>
</form>